
    import {defineComponent, toRefs, reactive} from 'vue';
    import {useRoute} from "vue-router";

    interface State {
        data: object;
        isShowModel: boolean;
        channelType: string;
    }

    export default defineComponent({
        name: "componentModel",
        props: {
            showModel: {
                type: Boolean,
                default: false,
            },
            data: {
                type: Object,
                default: () => {
                    return {}
                },
            },
        },
        setup(props: any) {
            let state: State = reactive({
                data: {},
                isShowModel: false,
                channelType: '',
            })
            const {query} = useRoute();
            const {showModel,data} = toRefs(props);
            state.channelType = `${query.channelType}` || '';
            state.data = data.value
            state.isShowModel = showModel
            return {
                state
            }
        },
        methods: {
            hiddenModel(){
                this.state.isShowModel = false
                this.$emit("parEvn", false)
            }
        }
    })
